import Banner from "@/components/landing/helpCenter2/Banner";
import ContactUs from "@/components/landing/helpCenter2/ContactUs";
import HelpCenterContent from "@/components/landing/helpCenter2/HelpCenterContent";

export default function HelpCenter2() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Help Center Content section */}
      <HelpCenterContent />

      {/* Contact Us section */}
      <ContactUs />
    </>
  );
}
